import { goRequest, goRequestWithRecaptcha } from '../utils/httpClient';

export const getDonationFunds = () =>
  goRequest({
    url: '/donation/funds',
    method: 'GET',
  });

export const getDonationProjects = () =>
  goRequest({
    url: '/donation/projects',
    method: 'GET',
  });

export const getBehalfOfTypes = () =>
  goRequest({
    url: '/donation/behalf_of_types',
    method: 'GET',
  });

export const createDonation = (data) =>
  goRequestWithRecaptcha('donation_from', {
    url: '/donation',
    method: 'POST',
    data: data,
  });

export const createDonationLines = (data) =>
  goRequestWithRecaptcha('donation_lines', {
    url: '/donation/lines',
    method: 'POST',
    data: data,
  });

export const getInProgressDonation = (data) =>
  goRequest({
    url: `/donation/inprogress/${data.id}`,
    method: 'GET',
  });

export const removeDonationLine = (data) =>
  goRequest({
    url: `/donation/lines/${data.id}`,
    method: 'DELETE',
  });

export const removeDonationNotification = (data) =>
  goRequest({
    url: `/donation/behalf_of/notification/${data.id}`,
    method: 'DELETE',
  });

export const getDonationList = (data) => {
  const page = (data.page ?? 0) + 1;
  let url = `/donations/list?page_size=${data.rowsPerPage}&page=${page}`;
  if (data.search) {
    url += `&search=${encodeURIComponent(data.search)}`;
  }
  if (data.orderBy) {
    url += `&order_by=${data.orderBy}`;
  }
  if (data.order) {
    url += `&order=${data.order}`;
  }
  if (data.ack_workflow_status) {
    url += `&ack_workflow_status=${encodeURIComponent(data.ack_workflow_status)}`;
  }
  if (data.local_chapter_id) {
    url += `&local_chapter_id=${encodeURIComponent(data.local_chapter_id)}`;
  }
  if (data.spd_chapter_id) {
    url += `&spd_chapter_id=${encodeURIComponent(data.spd_chapter_id)}`;
  }
  return goRequest({
    url,
    method: 'GET',
  });
};

export const createAcknowledgementBatch = () =>
  goRequest({
    url: '/donations/ack-batches',
    method: 'POST',
    data: {},
  });

export const getAcknowledgementBatch = (batchId) =>
  goRequest({
    url: `/donations/ack-batches/${encodeURIComponent(batchId)}`,
    method: 'GET',
  });

export const getAckBatchPickList = ({ batchId, page, rowsPerPage }) =>
  goRequest({
    url: `/donations/ack-batches/${encodeURIComponent(batchId)}/pick-list?page=${page}&page_size=${rowsPerPage}`,
    method: 'GET',
  });

export const addDonationsToAckBatch = ({ batchId, donation_ids }) =>
  goRequest({
    url: `/donations/ack-batches/${encodeURIComponent(batchId)}/items`,
    method: 'POST',
    data: { donation_ids },
  });

export const removeAckBatchItem = ({ batchId, itemId }) =>
  goRequest({
    url: `/donations/ack-batches/${encodeURIComponent(batchId)}/items/${encodeURIComponent(itemId)}`,
    method: 'DELETE',
  });

export const deleteAcknowledgementBatch = (batchId) =>
  goRequest({
    url: `/donations/ack-batches/${encodeURIComponent(batchId)}`,
    method: 'DELETE',
  });

export const getDonationDetail = (data) =>
  goRequest({
    url: `/donations/${data.id}`,
    method: 'GET',
  });

export const patchDonationAckWorkflow = ({ id, ack_workflow_status }) =>
  goRequest({
    url: `/donations/${id}/ack-workflow`,
    method: 'PATCH',
    data: { ack_workflow_status },
  });

export const getDonationChapters = () =>
  goRequest({
    url: '/donations/chapters',
    method: 'GET',
  });

export const getChapterDonorProfile = ({
  local_chapter_id,
  spd_chapter_id,
}) => {
  const params = new URLSearchParams();
  if (local_chapter_id) {
    params.set('local_chapter_id', local_chapter_id);
  }
  if (spd_chapter_id) {
    params.set('spd_chapter_id', spd_chapter_id);
  }
  return goRequest({
    url: `/donations/management/chapter-donor-profile?${params.toString()}`,
    method: 'GET',
  });
};

export const createInternalDonation = (data) =>
  goRequest({
    url: '/donations/management',
    method: 'POST',
    data,
  });

export const updateInternalDonationDonor = ({ id, ...data }) =>
  goRequest({
    url: `/donations/management/${id}/donor`,
    method: 'PATCH',
    data,
  });

export const createInternalDonationLine = ({ id, ...data }) =>
  goRequest({
    url: `/donations/management/${id}/lines`,
    method: 'POST',
    data,
  });

export const removeInternalDonationLine = ({ donationId, lineId }) =>
  goRequest({
    url: `/donations/management/${donationId}/lines/${lineId}`,
    method: 'DELETE',
  });

export const removeInternalDonationNotification = ({
  donationId,
  notificationId,
}) =>
  goRequest({
    url: `/donations/management/${donationId}/behalf_of/notification/${notificationId}`,
    method: 'DELETE',
  });

export const completeInternalDonationCheck = ({ id, ...data }) =>
  goRequest({
    url: `/donations/management/${id}/complete-check`,
    method: 'POST',
    data,
  });

export const createInternalDonationCardIntent = ({ id }) =>
  goRequest({
    url: `/donations/management/${id}/card/intent`,
    method: 'POST',
  });

export const confirmInternalDonationCardPayment = ({ id, payment_intent_id }) =>
  goRequest({
    url: `/donations/management/${id}/card/confirm`,
    method: 'POST',
    data: { payment_intent_id },
  });
